<template>
  <v-container class="pa-0">
    <v-row class="pa-0">
      <v-col cols="12" class="py-0">
        <v-col>
          <Search :organization_id="$route.params.id"></Search>
        </v-col>
        <CommonTable
          class="table"
          list-getter="projectStore/getList"
          :headers="headers"
          :slots="slots"
          :actions="actions"
          resource="projects"
          @updated="updateList"
          :loading.sync="loading"
        ></CommonTable>
        <Paginator page-getter="projectStore/getPage"></Paginator>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Paginator from "../common/tables/Paginator";
import Search from "../common/tables/Search";
import CommonTable from "../common/tables/CommonTable";

export default {
  name: "ProjectsOrganization",
  components: { Paginator, Search, CommonTable },
  data: function() {
    return {
      headers: [
        {
          text: this.$t("projects.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("projects.address"),
          value: "address"
        },
        {
          text: this.$t("projects.address-zip"),
          value: "address_zip"
        },
        {
          text: this.$t("projects.address-town"),
          value: "address_town"
        }
      ],
      actions: [],
      loading: false
    };
  },
  computed: {
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                ${this.organization}
                `;
    },
    organization() {
      return this.$store.getters["organizationStore/getItem"];
    },
    slots() {
      return [
        {
          name: "name",
          type: "link",
          to: "organization-project",
          staticLinkParams: { organization_id: this.$route.params.id }
        }
      ];
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      let params = {
        project_id: this.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders,
        organization_id: this.organization.id,
        filters: {
          "name;address_town;address_zip;address": this.$route.query.search
        }
      };
      return params;
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style scoped>
.table {
  height: calc(100vh - 370px);
}
</style>
